<div class="modal-wrapper schedule-modal" cf-loader-container position="bottom">
  <div cf-modal-header [hideCloseButton]="isNewUser"></div>
  <div class="modal-body">
    <h3>{{ "schedules.connect_your_calendar" | translate }}</h3>
    <cf-text color="grey-70" weight="400">
      {{ "schedules.connect_your_calendar_text_1" | translate }}
    </cf-text>
    <cf-text color="grey-70" weight="500" class="d-block">
      {{ "schedules.connect_your_calendar_text_2" | translate }}
    </cf-text>
    <div class="mt-4">
      <cf-google-button [isCalendar]="true" (callback)="connectGoogleCalendar($event)">
        {{ "schedules.google_calendar" | translate }}
      </cf-google-button>

      <cf-microsoft-button [isCalendar]="true" class="tw:mt-2 tw:w-full" redirectTarget="_blank">
        {{ "schedules.microsoft_calendar" | translate }}
      </cf-microsoft-button>

      @if (featureFlagService.isICloudEnabled()) {
        <button
          cfButton
          variant="secondary"
          class="tw:w-full tw:text-base tw:font-normal tw:mt-2"
          (click)="connectICloud()"
        >
          <img src="/assets/icons/icloud.svg" class="tw:size-6" />
          {{ "calendars.connect_icloud" | translate }}
        </button>
      }
    </div>
    <div class="mt-4 text-center" *ngIf="isNewUser">
      <a cf-link (click)="skipThisStep($event)">
        {{ "schedules.skip_this_step" | translate }}
      </a>
    </div>
  </div>
</div>
